import {
  SNSCallbackComponent,
  Platform,
} from "../components/SNSCallbackComponent"
import { container } from "../container"
import { withRouter } from "react-router"

class FacebookAuthCallback extends SNSCallbackComponent {
  protected platform = Platform.Facebook
}

export default container(withRouter(FacebookAuthCallback))
